import React, { useState, useEffect, useContext } from "react";
import { Link, useLocation } from 'react-router-dom';
import Logo from "../../public/assets/images/icons/logo-2.png";
import Logo2 from "../../public/assets/images/icons/rofda-logo.png";
import office1 from "../../public/assets/images/bg/office1.png";
import { AppContext } from "../Redux/ContextProvider";
import CustomButton from "../CustomButton";
const Header = ({ data, location, social }) => {
  const { appState, dispatch } = useContext(AppContext);
  const { loginInfo, loginLoader, loginMessage } = appState;
  const loggedInEmail = localStorage.getItem("loggedInEmail");
  // console.log(loggedInEmail);
  const [isSticky, setIsSticky] = useState(false);
  const homelocation = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 120);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  const isHome =
    homelocation.pathname === "/" || homelocation.pathname === "/home"  || homelocation.pathname === "/*";
  const isHomeClass = isHome && !isSticky;
  const showAltLogo = !isSticky && isHome;
  /*----for single sidebar event use one state-------*/
  const [sidebar, setSidebar] = useState(false);
  const [showSearch, setshowSearch] = useState(false);
  const [showMobileMenu, setMobileMenu] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(null);
  // const [showMobileSubMenu, setMobileSubMenu] = useState(false);
  // const handleMobileSubMenu = () => {
  //   if (showMobileSubMenu === false || showMobileSubMenu === 0) {
  //     setMobileSubMenu(1);
  //   } else {
  //     setMobileSubMenu(false);
  //   }
  // };
  const handleMobileMenu = () => {
    if (showMobileMenu === false || showMobileMenu === 0) {
      setMobileMenu(1);
    } else {
      setMobileMenu(false);
    }
  };
  // const showSidebarMenu = () => {
  //   if (sidebar === false || sidebar === 0) {
  //     setSidebar(1);
  //   } else {
  //     setSidebar(false);
  //   }
  // };
  const handleSearchbarBtn = () => {
    if (showSearch === false || showSearch === 0) {
      setshowSearch(1);
    } else {
      setshowSearch(false);
    }
  };

  const Bars = (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24"><path fill="currentColor" d="M4 6a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m0 12a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1m7-7a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2z" /></svg>
  );
  const CallIco = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <g fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth="2">
        <path d="M8 3C8.5 3 10.5 7.5 10.5 8C10.5 9 9 10 8.5 11C8 12 9 13 10 14C10.3943 14.3943 12 16 13 15.5C14 15 15 13.5 16 13.5C16.5 13.5 21 15.5 21 16C21 18 19.5 19.5 18 20C16.5 20.5 15.5 20.5 13.5 20C11.5 19.5 10 19 7.5 16.5C5 14 4.5 12.5 4 10.5C3.5 8.5 3.5 7.5 4 6C4.5 4.5 6 3 8 3Z">
          <animate fill="freeze" dur="0.6s" values="64;0" />
          <animateTransform attributeName="transform" begin="0.6s;lineMdPhoneCallLoop0.begin+2.6s" dur="0.5s" type="rotate" values="0 12 12;15 12 12;0 12 12;-12 12 12;0 12 12;12 12 12;0 12 12;-15 12 12;0 12 12" />
        </path>
        <path d="M14 7.04404C14.6608 7.34734 15.2571 7.76718 15.7624 8.27723M16.956 10C16.6606 9.35636 16.2546 8.77401 15.7624 8.27723" opacity="0">
          <set id="lineMdPhoneCallLoop0" attributeName="opacity" begin="0.7s;lineMdPhoneCallLoop0.begin+2.7s" to="1" />
          <animate fill="freeze" begin="0.7s;lineMdPhoneCallLoop0.begin+2.7s" dur="0.2s" values="4;8" />
          <animate fill="freeze" begin="1.3s;lineMdPhoneCallLoop0.begin+3.3s" dur="0.3s" values="0;4" />
          <set attributeName="opacity" begin="1.6s;lineMdPhoneCallLoop0.begin+3.6s" to="0" />
        </path>
        <path d="M20.748 9C20.3874 7.59926 19.6571 6.347 18.6672 5.3535M15 3.25203C16.4105 3.61507 17.6704 4.3531 18.6672 5.3535" opacity="0">
          <set attributeName="opacity" begin="1s;lineMdPhoneCallLoop0.begin+3s" to="1" />
          <animate fill="freeze" begin="1s;lineMdPhoneCallLoop0.begin+3s" dur="0.2s" values="10;20" />
          <animate fill="freeze" begin="1.5s;lineMdPhoneCallLoop0.begin+3.5s" dur="0.3s" values="0;10" />
          <set attributeName="opacity" begin="1.8s;lineMdPhoneCallLoop0.begin+3.8s" to="0" />
        </path>
      </g>
    </svg>
  );
  return (
    <>
      <div
        className={
          sidebar === 1
            ? "menu-toggle-btn-full-shape show-sidebar"
            : "menu-toggle-btn-full-shape"
        }
      >
        <div className="menu-toggle-wrap bg-white">
          <div className="sidebar-top-area d-flex justify-content-between align-items-center">
            <div className="sidebar-logo rounded">
              <Link to="#">
                {" "}
                <img src={Logo} alt="logo-size" className="logo-size" />
              </Link>
            </div>
            {/* <div className="cross-icon" onClick={showSidebarMenu}>
              <i className="bx bx-x" />
            </div> */}
          </div>
          <div className="sidebar-body">
            <div className="address-card mb-4">
              <div className="content">
                <div className="header">
                  <div className="location">
                    <svg
                      width={18}
                      height={22}
                      viewBox="0 0 18 22"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M9 22C9 22 17.25 14.1818 17.25 8.25C17.25 6.06196 16.3808 3.96354 14.8336 2.41637C13.2865 0.869194 11.188 0 9 0C6.81196 0 4.71354 0.869194 3.16637 2.41637C1.61919 3.96354 0.75 6.06196 0.75 8.25C0.75 14.1818 9 22 9 22ZM9 12.375C7.90598 12.375 6.85677 11.9404 6.08318 11.1668C5.3096 10.3932 4.875 9.34402 4.875 8.25C4.875 7.15598 5.3096 6.10677 6.08318 5.33318C6.85677 4.5596 7.90598 4.125 9 4.125C10.094 4.125 11.1432 4.5596 11.9168 5.33318C12.6904 6.10677 13.125 7.15598 13.125 8.25C13.125 9.34402 12.6904 10.3932 11.9168 11.1668C11.1432 11.9404 10.094 12.375 9 12.375Z" />
                    </svg>
                  </div>
                  <h3>{location.City}</h3>
                </div>
                <ul className="address-list">
                  <li>
                    <span>Address: </span>
                    {location.AddressLine1} {location.AddressLine2}{" "}
                    {location.City}, {location.StateName} {location.ZipCode}
                  </li>
                  <li>
                    <span>Phone:</span> +{location.StorePhoneNumber}
                  </li>
                  <li>
                    <span>Email:</span> {location.StoreEmail}
                  </li>
                </ul>
              </div>
              {/* <img src={office1} alt="webco" /> */}
            </div>
            <div className="blog-widget-item mb-0">
              <h5 className="blog-widget-title mb-1">Follow Us</h5>
              <p className="para">Follow us on Social Network</p>
              <div className="blog-widget-body">
                <ul className="follow-list d-flex flex-row align-items-start gap-4">
                  {social.facebook_url ? (
                    <li>
                      <a href={`${social.facebook_url}`}>
                        <i className="bx bxl-facebook" />
                      </a>
                    </li>
                  ) : (
                    ""
                  )}
                  {social.twitter_url ? (
                    <li>
                      <a href={`${social.twitter_url}`}>
                        <i className="bx bxl-twitter" />
                      </a>
                    </li>
                  ) : (
                    ""
                  )}
                  {social.linkedin_url ? (
                    <li>
                      <a href={`${social.linkedin_url}`}>
                        <i className="bx bxl-linkedin" />
                      </a>
                    </li>
                  ) : (
                    ""
                  )}
                  {social.pintrest_url ? (
                    <li>
                      <a href={`${social.pintrest_url}`}>
                        <i className="bx bxl-pinterest" />
                      </a>
                    </li>
                  ) : (
                    ""
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={showSearch === 1 ? "mobile-search slide" : "mobile-search"}
      >
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-md-11">
              <label>What are you lookking for?</label>
              <input
                type="text"
                placeholder="Search Products, Category, Brand"
              />
            </div>
            <div className="col-1 d-flex justify-content-end align-items-center gap-2">
              <div className="search-cross-btn">
                <i className="bx bx-search-alt-2" />
              </div>
              <div className="search-cross-btn" onClick={handleSearchbarBtn}>
                <i className="bi bi-x" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <header className={`header-area style-4 ${isSticky ? "sticky" : ""}`} >
        <div className={`header-wrap navbar ${isHomeClass ? "home" : ""} `} >
          <div className={`container ${isHomeClass ? 'semi-container' : ''}`}>
            <div className="header-logo">
              <Link to="/" style={{ cursor: isHome ? "default" : "pointer", }}>
                <img
                  src={showAltLogo ? Logo : Logo2}
                  alt="logo" className="img-fluid"
                />
              </Link>
            </div>
            <div
              className={showMobileMenu === 1 ? "main-nav mobile-menu-main show-menu" : "mobile-menu-main main-nav"}
            >
              <div className="mobile-logo-area mb-20 d-lg-none d-flex justify-content-between align-items-center">
                <div className="mobile-logo-wrap ">
                  <Link to="/" style={{ cursor: isHome ? "default" : "pointer", }}>
                    <img alt="webco" src={Logo2} className="logo-size" />
                  </Link>
                </div>
                <div onClick={handleMobileMenu} className="menu-close-btn">
                  <i
                    className={
                      showMobileMenu === 1
                        ? "bi bi-x-lg bi-chevron-down"
                        : "bi bi-x-lg bi-chevron-up"
                    }
                  />
                </div>
              </div>
              <ul className="menu-list">
                {data &&
                  data.length &&
                  data.map((info) => {
                    return (
                      <li className="menu-item-has-children" key={info.menu_id}>
                        <Link to={`/${info.menu_url}`} className="drop-down">
                          <span>{info.menu_name}</span>
                        </Link>
                        {info.submenu && info.submenu.length > 0 && (
                          <>
                            <i
                              className="bi bi-chevron-down dropdown-icon"
                              onClick={() => setOpenSubMenu(openSubMenu === info.menu_id ? null : info.menu_id)}
                            />
                            <ul className={openSubMenu === info.menu_id ? "sub-menu d-block" : "sub-menu d-none"}>
                              {info.submenu.map((val, index) => {
                                return (
                                  <li key={index}>
                                    <Link to={`/${val.menu_url}`}>
                                      {val.menu_name}
                                    </Link>
                                  </li>
                                );
                              })}
                            </ul>
                          </>
                        )}
                      </li>
                    );
                  })}
              </ul>
              <div className="d-lg-none">
                <ul className="contact-list ">
                  <li>
                    <div className="icon">
                      {CallIco}
                    </div>
                    <div className="info">
                      <span className="title">Click To Call</span>
                      <div className="text">
                        <Link to="tel:1 (205) 683-3400">+1 (205) 683-3400</Link></div>
                    </div>
                  </li>
                </ul>
                <div className="social-icon">
                  <ul className="list-unstyled">
                    {social.facebook_url ?
                      <li className="facebook">
                        <a target={"_blank"} href={`${social.facebook_url}`}>
                          <i className="bx bxl-facebook" />
                        </a>
                      </li>
                      : ''}
                    {social.twitter_url ?
                      <li className="twitter">
                        <a target={"_blank"} href={`${social.twitter_url}`}>
                          <i className="bx bxl-twitter" />
                        </a>
                      </li>
                      : ''}
                    {social.linkedin_url ?
                      <li className="linkedin">
                        <a target={"_blank"} href={`${social.linkedin_url}`}>
                          <i className="bx bxl-linkedin" />
                        </a>
                      </li> : ''}
                    {social.pintrest_url ?
                      <li className="pinterest">
                        <a target={"_blank"} href={`${social.pintrest_url}`}>
                          <i className="bx bxl-pinterest-alt" />
                        </a>
                      </li>
                      : ''}
                  </ul>
                </div>
              </div>
            </div>
            <div className="nav-right d-flex align-items-center">
              <div className="mobile-menu-btn d-lg-none d-block">
                <h5
                  className="text-dark mb-0"
                  onClick={handleMobileMenu}
                  style={{ cursor: "pointer" }}
                >
                  <span>MENU</span>
                  <div className="icon bar">{Bars}</div>
                </h5>
              </div>
              <div className="hotline d-xxl-flex d-none">
               {/*  <a href={`mailto:${location.StoreEmail}`}>
                <div className="hotline-icon icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width={34}
                    height={34} viewBox="0 0 24 24"><path fill="currentColor" d="m16.484 11.976l6.151-5.344v10.627zm-7.926.905l2.16 1.875c.339.288.781.462 1.264.462h.017h-.001h.014c.484 0 .926-.175 1.269-.465l-.003.002l2.16-1.875l6.566 5.639H1.995zM1.986 5.365h20.03l-9.621 8.356a.6.6 0 0 1-.38.132h-.014h.001h-.014a.6.6 0 0 1-.381-.133l.001.001zm-.621 1.266l6.15 5.344l-6.15 5.28zm21.6-2.441c-.24-.12-.522-.19-.821-.19H1.859a1.9 1.9 0 0 0-.835.197l.011-.005A1.86 1.86 0 0 0 0 5.855v12.172a1.86 1.86 0 0 0 1.858 1.858h20.283a1.86 1.86 0 0 0 1.858-1.858V5.855c0-.727-.419-1.357-1.029-1.66l-.011-.005z" /></svg>
                </div>
                </a>
                <div className="hotline-info">
              <span>Mail Us</span>
              <h6>
                <a href={`mailto:${location.StoreEmail}`}>
                  {location.StoreEmail}
                </a>
              </h6>
            </div> */}
              </div>
              {loggedInEmail !== null ? (
                <>
                  <div className="eg-btn log-out-wrap">
                    <Link
                      to="/login"
                      onClick={() => {
                        localStorage.removeItem("loggedInEmail");
                        window.location.reload("/login");
                      }}
                    >
                      <div className="icon"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 15 15"><path fill="none" stroke="currentColor" d="m13.5 7.5l-3 3.25m3-3.25l-3-3m3 3H4m4 6H1.5v-12H8" strokeWidth="1.3" /></svg></div>
                      <span>Logout</span>
                    </Link>
                    {/* <>
                  <i className="bi bi-chevron-down dropdown-icon" />
                </> */}
                  </div>
                </>
              ) : (
                <div className="eg-btn login-wrap">
                  <Link to="/login">
                    <div className="icon"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M12 21v-2h7V5h-7V3h9v18zm-2-4l-1.375-1.45l2.55-2.55H3v-2h8.175l-2.55-2.55L10 7l5 5z" /></svg></div>
                    <span>Login</span>
                  </Link>
                </div>
              )}
              <div className="eg-btn btn--primary2 capsule log-out-btn d-xxl-flex d-none">
                <Link to="/contact-us">
                  Contact Us<CustomButton />
                </Link>
              </div>
              {/* <div className="header-icons d-flex align-items-center">
            <div className="sidebar-btn" onClick={showSidebarMenu}>
              <i className="bi bi-list" />
            </div>
          </div> */}
            </div>
          </div>
        </div>
      </header>
    </>
  );
};
export default Header;
